// src/components/Access.js
import React from 'react';
import useReveal from '../hooks/useReveal';
import { CONTACT } from '../data/services';

function Access() {
  const sectionRef = useReveal();

  return (
    <section id="access" className="reveal" ref={sectionRef}>
      <div className="section-content">
        <span className="section-eyebrow">Access</span>
        <h2 className="section-title">ติดต่อ & การเดินทาง</h2>
        <div className="access-container">
          <div className="access-details">
            <h3>Pet Direct Hospital</h3>
            <ul className="access-list">
              <li>
                <span className="material-icons" aria-hidden="true">place</span>
                <span>{CONTACT.address}</span>
              </li>
              <li>
                <span className="material-icons" aria-hidden="true">call</span>
                <a href={CONTACT.phoneHref}>{CONTACT.phone}</a>
              </li>
              <li>
                <span className="material-icons" aria-hidden="true">mail</span>
                <a href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a>
              </li>
              <li>
                <span className="material-icons" aria-hidden="true">chat</span>
                <span>LINE: {CONTACT.lineId}</span>
              </li>
            </ul>
            <div className="access-actions">
              <a
                href={CONTACT.lineUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="access-line"
              >
                <span className="material-icons" aria-hidden="true">chat</span>
                จองคิวผ่าน LINE
              </a>
              <a
                href={CONTACT.mapUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="access-map-link"
              >
                <span className="material-icons" aria-hidden="true">map</span>
                เปิดใน Google Maps
              </a>
            </div>
          </div>
          <div className="map-container">
            <iframe
              src={CONTACT.mapEmbedUrl}
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="แผนที่ Pet Direct Hospital"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Access;
